import React from 'react';
import config from '../config/constants';
import PoweredBy from '../components/PoweredBy';
import IFrameService from '../service/IFrameService';

export default class Login extends React.Component {
	
	state = {
		username: '',
		password: '',
		remember: false
	};
	
	componentDidMount = () => {
		IFrameService.parentData();
	};
	
	componentDidUpdate = () => {
		IFrameService.parentData();
	};
	
	userLogin = () => {
		if (this.state.remember) {
			// save cookie
		}
	};
	
	render = () => {
		
		return (
			<div className="container">
				
				<div className="flex-parent">
					<div className="flex-child">
						<h3 className="rcg-small-title text-outline">Vacancies</h3>
						<h1>Login</h1>
					</div>
				</div>
				
				<div className="flex-parent">
					<div className="flex-child-list">
						<ul>
							
							<li className="gfield gfield_genesis">
								{(this.state.username === '') && (
									<label className="gfield_label" htmlFor="username">Username</label>)}
								<div className="ginput_container">
									<input name="username" id="username" type="text" value={this.state.username} onChange={(event) => {
										this.setState({
											username: event.target.value
										})
									}}/>
								</div>
							</li>
							
							<li className="gfield gfield_genesis">
								{(this.state.username === '') && (
									<label className="gfield_label" htmlFor="password">Password</label>)}
								<div className="ginput_container">
									<input name="password" id="password" type="password" value={this.state.password} onChange={(event) => {
										this.setState({
											password: event.target.value
										})
									}}/>
								</div>
							</li>
							
							<li className="gfield gfield_genesis_checkbox">
								<div className="ginput_container ginput_container_checkbox">
									<ul className="gfield_checkbox">
										<li>
											<input name="RememberMe" type="checkbox" value={this.state.remember} id="remember" onChange={(event) => {
												this.setState({
													remember: event.target.value
												})
											}}/>
											<label htmlFor="remember">Remember me</label>
										</li>
									</ul>
								</div>
							</li>
							<li className="gfield gfield_genesis_login_button">
								<button className="btn btn_submit" onClick={() => this.userLogin()}>
									<span className="text-outline">Login</span>
									<span className="btn_bg"/>
								</button>
							</li>
						</ul>
					</div>
				</div>
				
				<div className="flex-parent">
					<div className="flex-child">
						<p className="user-content rcg-forget-link">
							<a
								href={`${config.PROTOCOL}://${config.DOMAIN}/index.php?option=com_user&view=reset&lang=en`}
								title="Forgot your password"
								target="__blank"
							>Forgot your password
							</a>&nbsp;/&nbsp;
							<a
								href={`${config.PROTOCOL}://${config.DOMAIN}/index.php?option=com_user&view=remind&lang=en`}
								title="Forgot your password"
								target="__blank"
							>Forgot your username
							</a>
						</p>
					</div>
				</div>
				
				<PoweredBy />
				
			</div>
		);
	};
}


// WEBPACK FOOTER //
// ./src/pages/Login.js